function updateSelectric(vue) {
  /**
   * In order to get selectric to work with Vue, we have to
   * tell selectric to render the dropdown right after
   * vue is initially rendered.
   */
  vue.$nextTick(function () {
    var _this = this;
    var $el = $(this.$el);
    sw.trigger('sw-fragment-loaded', $el);
    // Listen to changes in the selectric dropdown and pass it to the the Vue object method
    $el.on('selectric-change', function (e, el) {
      _this.updateQuantity(el.value);
    });
  });
}

module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-add-to-cart]').each(function () {
    var el = this;
    var $this = $(this);
    var modelId = $this.attr('data-sw-model-material-configurator-add-to-cart');
    var template = $this.find('[data-sw-model-material-configurator-add-to-cart-template]').get(0);

    require(
      [
        'vue',
        'vuex',
        'rrViewComponents/Model/MaterialConfigurator/sw-model-material-configurator-module',
      ], function (vue, vuex, modelMaterialConfiguratorModule) {

        new vue({
          el: el,
          data: {
            versatilePlastics: [6, 25, 62, 75, 76, 77, 78, 93, 94, 95, 133, 134],
            modelId: modelId,
            quantity: 1
          },
          template: template,
          mounted: function () {
            updateSelectric(this);
          },
          updated: function () {
            updateSelectric(this);
          },
          store: modelMaterialConfiguratorModule,
          computed: vuex.mapState({
            showInput: function () {
              return this.quantity > '9';
            },
            hasMaterialGroupSelected: function (state) {
              return state[this.modelId].hasMaterialGroupSelected;
            },
            hasBulkDiscount: function (state) {
              return this.versatilePlastics.includes(state[this.modelId].materialId);
            },
            deliveryDate: function (state) {
              return state[this.modelId].deliveryDate;
            },
            addedToCart: function (state) {
              return state[this.modelId].addedToCart;
            },
            addToCartPrice: function (state) {
              return state[this.modelId].addToCartPrice;
            },
            materialId: function (state) {
              return state[this.modelId].materialId;
            },
            productConfigurationId: function (state) {
              return state[this.modelId].productConfigurationsByMaterialIds[this.materialId];
            },
            isLoading: function(state) {
                return state[this.modelId].isLoading || false;
            },
            fetching: function(state) {
              return state[this.modelId].fetching || false;
            }
          }),
          methods: {
            addToCart: function (event) {
              modelMaterialConfiguratorModule.dispatch('modelMaterialConfigurator/addToCart', {
                modelId: this.modelId,
                productConfigurationId: this.productConfigurationId,
                productId: event.target.elements.productId.value,
                quantity: event.target.elements.count.value,
                csrf: event.target.elements._csrf.value
              });
            },
            updateQuantity: function (quantity) {
              this.quantity = parseInt(quantity);
            }
          }
        });
      }
    );
  });
};
